import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getDownloadURL, listAll, ref } from "firebase/storage";
import {  storage, storageRef } from '../firebase';
import Confetti from 'react-confetti';
import jsPDF from 'jspdf';
import ReactWaterMark from "react-watermark-component";


const Certificates = () => {
  const { id } = useParams();
  const [fileExists, setFileExists] = useState(true);
  const [isConfettiActive, setConfettiActive] = useState(true);
  const [imageUrl, setImageUrl] = useState('');


    useEffect(()=>{
  
    listAll(ref(storage,"lifeguard-certificate")).then(certificate=>{
        let find=null
        find=certificate.items.find((item)=>(item._location.path_.substring(item._location.path_.lastIndexOf('/') + 1)===id+".png"))

        if(find!=null && find!==undefined)
        {
            setFileExists(true);
           fetchFile()
           setConfettiActive(true)
        }
        else
        {setFileExists(false)};
        }
        )
    },[])

const stopConfetti = () => {
    setConfettiActive(false);
  };

const fetchFile=()=>{
    getDownloadURL(ref(storage, 'lifeguard-certificate/'+id+".png"))
    .then((url) => {
      
      setImageUrl(url);

      // This can be downloaded directly:
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = (event) => {
        const blob = xhr.response;
      };
      xhr.open('GET', url);
      xhr.send();
  
      // Or inserted into an <img> element
      // const img = document.getElementById('myimg');
      // img.setAttribute('src', url);


    })
    .catch((error) => {
      // Handle any errors
    });
}
const downloadPNG = () => {
  const link = document.createElement('a');
  link.href = imageUrl;
  link.download = `certificate-${id}.png`;
  link.click();
};

const downloadPDF = () => {
  const doc = new jsPDF();
  doc.addImage(imageUrl, 'PNG', 0, 0);
  doc.save(`certificate-${id}.pdf`);
};
const options = {
  chunkWidth: 200,
  chunkHeight: 60,
  textAlign: "left",
  textBaseline: "bottom",
  globalAlpha: 0.4,
  font: "20px Poppins",
  rotateAngle: -0.26,
  fillStyle: "#0072c4"
};

  return (
    <div className=''>
      {fileExists ? (
        <div className='lg:flex'>
                <div className='flex flex-grow flex-col justify-center '>
                    <div className='lg:px-10 p-5'>
                        <h2 className="font-light lg:text-7xl text-4xl text-gray-400"> Swimmunity </h2>
                        <h2 className="font-light lg:text-7xl  text-4xl text-blue-500">verified</h2>
                        <span className='p-1 lg:px-10 px-3 text-xs lg:text-sm text-green-600 inline-block my-4 rounded-full border-2 border-green-600'>Certification validation successful!</span>
                    </div>
                    <div className='lg:px-10 p-5 font-light text-gray-500 lg:text-xl'>
                        <p>Congratulations! The certificate with ID {id} has been successfully validated.</p>

                        <p>This certificate is authentic and has been verified as valid.</p>
                    </div>
                    <div className='flex lg:px-10 px-5 pb-10 gap-5'>
                        {/* <button onClick={downloadPDF} download className='bg-blue-500 rounded-xl p-3 text-white lg:px-8'>Download PDF</button>
                        <button onClick={downloadPNG} className='bg-blue-500 rounded-xl p-3 text-white lg:px-8'>Download PNG</button> */}
                    </div>

                </div>
                <ReactWaterMark
      waterMarkText="verified"
      openSecurityDefense
      options={options}
    >
       {/* <div className='h-screen p-10 w-screen lg:w-[33vw]'  style={{
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: 'cover',
              pointerEvents:'none'
              
              
            }}></div> */}
           <img id="myimg" className='lg:h-screen p-5 pointer-events-none'src={imageUrl}></img>

    </ReactWaterMark>
               
                {isConfettiActive && (
        <Confetti
          width={window.innerWidth}
          height={window.innerHeight}
          recycle={false} // Set to true for continuous confetti
          numberOfPieces={500}
          onConfettiComplete={stopConfetti} // Callback when confetti completes
        />
      )}
        </div>
      ) : (
        <div className='lg:flex min-h-screen '>
            <div className='my-auto flex-grow flex flex-col justify-center '>
                    <div className='p-10'>
                        <h2 className="font-light lg:text-7xl text-4xl text-gray-400"> Swimmunity </h2>
                        <h2 className="font-light lg:text-7xl text-4xl text-blue-500">verify</h2>
                        <span className='p-1 px-5 lg:px-10 text-red-600 inline-block my-4 text-sm rounded-full border-2 border-red-600'>Certification validation unsuccessful!</span>
                    </div>
                    <div className='px-10 font-light text-gray-500 text-xl lg:text-4xl'>
                        

                        <p>This certificate is invalid!</p>
                    </div>
                   

                </div>
            <img className='max-h-screen' src="/not-found.jpg"></img>
     
        </div>
        
      )}
    </div>
  );
};

export default Certificates;
